import { render } from "./pictures.vue?vue&type=template&id=3344144e"
import script from "./pictures.vue?vue&type=script&lang=js"
export * from "./pictures.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"vendor/wielink-application/shared/resources/vue/components/form/horizontal/pictures.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3344144e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3344144e', __exports__)) {
    console.log('reload')
    api.reload('3344144e', __exports__)
  }
  
  module.hot.accept("./pictures.vue?vue&type=template&id=3344144e", () => {
    console.log('re-render')
    api.rerender('3344144e', render)
  })

}


export default __exports__